<template>
  <div class="container">
    <span class="title">{{ title }}</span>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem prop="oldpwd" label="旧密码">
        <Input v-model="formValidate.oldpwd" type="password" placeholder="旧密码" />
      </FormItem>
      <FormItem prop="newpwd" label="新密码">
        <Input v-model="formValidate.newpwd" type="password" placeholder="新密码" />
      </FormItem>
      <FormItem prop="passwdCheck" label="重复密码">
        <Input v-model="formValidate.passwdCheck" type="password" placeholder="重复密码" />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="save" style="flex: 1; margin: 10px 0" long>确定</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  name: "core-resetPwd",
  props: {
    closable: {
      tyoe: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let { verification_rules, error_prompt, verification_func } = this.$app.Cfg.core.account_security
    const PWDRegExp = new RegExp(verification_rules)
    const validatePass = async (rele, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else {
        let hook = null
        try {
          hook = await fxImport("./web/config/core/hook.config.js")
        } catch (error) {}

        if (hook && hook.verificationUserPwd) {
          try {
            await hook.verificationUserPwd(value)
          } catch (error) {
            callback(error)
          }
        } else if (!PWDRegExp.test(value)) {
          callback(new Error(error_prompt))
        }

        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck")
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.formValidate.newpwd) {
        callback(new Error("两次密码不一样"))
      } else {
        callback()
      }
    }

    
    let title = this.$store.state.core.user.statusDescript || "账号需要重置密码"

    return {
      title,
      formValidate: {
        oldpwd: "",
        newpwd: "",
        passwdCheck: "",
      },
      ruleValidate: {
        oldpwd: [{ required: true, message: "旧密码不能为空", trigger: "blur" }],
        newpwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ required: true, validator: validatePassCheck, trigger: "blur" }],
      },
    }
  },
  computed: {},
  methods: {
    save() {
      let enctyptLoginPWD = window.fx_packaging_loginpwd
      let _this = this
      this.$refs.formValidate.validate((valid) => {
        // console.log(_this.$app.ProjSetting)

        if (valid) {
          let { oldpwd, newpwd } = _this.formValidate
          let _form = {}
          if (_this.$app.ProjSetting.isCryptoLoginPWD) {
            oldpwd = enctyptLoginPWD(oldpwd)
            newpwd = enctyptLoginPWD(newpwd)
          }
          _form["oldpwd"] = oldpwd
          _form["newpwd"] = newpwd
          _this.$curl.post("/api/core/personal/modifypwd", _form).then(() => {
            _this.$Message.info("修改成功")
            this.$refs.formValidate.resetFields()
            this.$store.dispatch("core/logout")
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  width: 400px;
  margin: 0 auto;
  .title {
    margin-top: 100px;
    display: block;
    font-size: 18px;
    text-align: center;
    margin-bottom: 35px;
    font-weight: bold;
  }
}
</style>